"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBuildActive = isBuildActive;
exports.isAnalyseActive = isAnalyseActive;
exports.showBackButton = showBackButton;
exports.showNextButton = showNextButton;
exports.backButtonLink = backButtonLink;
exports.nextButtonLink = nextButtonLink;

function matches(urlArray, location) {
  if (urlArray.find(function (url) {
    return url === location.pathname;
  })) {
    return true;
  }

  return false;
}

function isActive(match) {
  if (match) {
    return true;
  }

  return false;
}

function activeOrMatches(match, urlArray, location) {
  if (isActive(match) || matches(urlArray, location)) {
    return true;
  }

  return false;
}

function isBuildActive(match, location) {
  if (activeOrMatches(match, ['/campaign-creator/find-personas', '/campaign-creator/select-personas'], location)) {
    return true;
  }

  return false;
}

function isAnalyseActive(match, location) {
  if (activeOrMatches(match, ['/campaign-creator/audience-profiling', '/campaign-creator/full-persona'], location)) {
    return true;
  }

  return false;
}

var landingPageURLs = {
  one: '/campaign-creator/getting-started-new',
  two: '/campaign-creator/analyse-audience',
  three: '/campaign-creator/deliver-campaign'
};
/**
 * Do not show back button on first landing page.
 */

function showBackButton(location) {
  if (location === landingPageURLs.one) {
    return false;
  }

  return true;
}
/**
 * Do not show next on landing pages.
 */


function showNextButton(location) {
  if (Object.values(landingPageURLs).find(function (f) {
    return f === location;
  })) {
    return false;
  }

  return true;
}

function backButtonLink(location) {
  var urls = {
    one: ['/campaign-creator/find-personas', '/campaign-creator/select-personas', '/campaign-creator/analyse-audience'],
    two: ['/campaign-creator/audience-profiling', '/campaign-creator/full-persona', '/campaign-creator/deliver-campaign']
  };

  if (urls.one.find(function (f) {
    return f === location;
  })) {
    return landingPageURLs.one;
  }

  if (urls.two.find(function (f) {
    return f === location;
  })) {
    return landingPageURLs.two;
  }

  return '#';
}

function nextButtonLink(location) {
  var urls = {
    one: ['/campaign-creator/find-personas', '/campaign-creator/select-personas'],
    two: ['/campaign-creator/audience-profiling', '/campaign-creator/full-persona']
  };

  if (urls.one.find(function (f) {
    return f === location;
  })) {
    return landingPageURLs.two;
  }

  if (urls.two.find(function (f) {
    return f === location;
  })) {
    return landingPageURLs.three;
  }

  return '#';
}